import axios from '../config/axiosConfig';

const API_URL = '/settings';

// Get application settings
const getSettings = async () => {
  const response = await axios.get(API_URL);
  return response.data;
};

// Update application settings (admin only)
const updateSettings = async (updates) => {
  const response = await axios.put(API_URL, updates);
  return response.data;
};

// Upload logo
const uploadLogo = async (file, type = 'logo') => {
  const formData = new FormData();
  formData.append('logo', file);
  formData.append('type', type);

  const response = await axios.post(`${API_URL}/logo`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

// Remove logo
const removeLogo = async (type = 'logo') => {
  const response = await axios.delete(`${API_URL}/logo/${type}`);
  return response.data;
};

// Test email settings
const testEmail = async () => {
  const response = await axios.post(`${API_URL}/test-email`);
  return response.data;
};

// Get translations for a language
const getTranslations = async (lang) => {
  const response = await axios.get(`${API_URL}/translations/${lang}`);
  return response.data;
};

// Available languages info
const languageInfo = {
  en: { name: 'English', nativeName: 'English', flag: 'gb' },
  de: { name: 'German', nativeName: 'Deutsch', flag: 'ch' },
  fr: { name: 'French', nativeName: 'Français', flag: 'ch' },
  it: { name: 'Italian', nativeName: 'Italiano', flag: 'ch' }
};

// Date format options
const dateFormats = [
  { value: 'MM/DD/YYYY', label: 'MM/DD/YYYY (US)' },
  { value: 'DD/MM/YYYY', label: 'DD/MM/YYYY (EU)' },
  { value: 'YYYY-MM-DD', label: 'YYYY-MM-DD (ISO)' },
  { value: 'DD.MM.YYYY', label: 'DD.MM.YYYY (CH)' }
];

// Time format options
const timeFormats = [
  { value: '12h', label: '12-hour (AM/PM)' },
  { value: '24h', label: '24-hour' }
];

// Common timezones
const timezones = [
  { value: 'Europe/Zurich', label: 'Europe/Zurich (CET/CEST)' },
  { value: 'Europe/London', label: 'Europe/London (GMT/BST)' },
  { value: 'Europe/Paris', label: 'Europe/Paris (CET/CEST)' },
  { value: 'Europe/Berlin', label: 'Europe/Berlin (CET/CEST)' },
  { value: 'America/New_York', label: 'America/New_York (EST/EDT)' },
  { value: 'America/Los_Angeles', label: 'America/Los_Angeles (PST/PDT)' },
  { value: 'America/Chicago', label: 'America/Chicago (CST/CDT)' },
  { value: 'Asia/Tokyo', label: 'Asia/Tokyo (JST)' },
  { value: 'Asia/Singapore', label: 'Asia/Singapore (SGT)' },
  { value: 'Australia/Sydney', label: 'Australia/Sydney (AEST/AEDT)' },
  { value: 'UTC', label: 'UTC' }
];

const settingsService = {
  getSettings,
  updateSettings,
  uploadLogo,
  removeLogo,
  testEmail,
  getTranslations,
  languageInfo,
  dateFormats,
  timeFormats,
  timezones
};

export default settingsService;
